<template>

        <menu v-if="links !== false"  class="valign">
            <template v-if="mobile">
                <router-link :to="links[0].path" class="valign menu-btn menu-btn__left" v-if="!mobMenuShow && links[0].name != ''" @click.native = "gaNav"> <Arrow></Arrow> <span>{{links[0].name}}</span></router-link>
                <router-link :to="links[1].path" class="valign menu-btn menu-btn__right" v-if="!mobMenuShow && links[0].name != ''"  @click.native = "gaNav"> <span>{{links[1].name}}</span> <Arrow></Arrow> </router-link>
            </template>
            <!--ANIMATED NAV START-->

            <template v-if="!mobile">
                <div class="anim-nav-menu" v-if="!mobMenuShow && links[0].name != '' ">
                    <div class="anim-container">
                        <div :class="'anim-wrapper '+ animTurn">
                            <!--<router-link :to="links[0].path" class="valign menu-btn menu-btn__left" v-if="!mobMenuShow && links[0].name != '' "> <Arrow></Arrow> <span>{{links[0].name}}</span></router-link>-->
                            <!--<router-link :to="links[1].path" class="valign menu-btn menu-btn__right" v-if="!mobMenuShow && links[0].name != ''" > <span>{{links[1].name}}</span> <Arrow></Arrow> </router-link>-->
                            <router-link to="/recipes" class="menu-btn left" @click.native = "gaNav"><Arrow></Arrow><span>Рецепты</span></router-link>
                            <router-link :to="testNavLink" class="menu-btn top" @click.native = "gaNav"><Arrow></Arrow><span>Тест</span></router-link>
                            <router-link to="/about" class="menu-btn right" @click.native = "gaNav"><Arrow></Arrow><span>О продукте</span></router-link>
                            <router-link :to="bottomNav.link" class="menu-btn bottom" @click.native = "gaNav"><Arrow></Arrow><span>{{bottomNav.text}}</span></router-link>
                        </div>
                        <img src="/static/images/ellipse.png" alt="">
                    </div>
                </div>
            </template>

            <!--ANIMATED NAV END-->


            <a href="#" class="btn-share" @click.prevent="showSharing" >
                <Share></Share>
            </a>

            <transition name="fade">

                <!--<div class="social social-click" v-if="show">-->
                    <!--<a href="#" class="fb"><FB></FB></a>-->
                    <!--<a href="#" class="vk"><VK></VK></a>-->
                    <!--<a href="#" class="tw"><Twitter></Twitter></a>-->
                    <!--<a href="#" class="ok"><OK></OK></a>-->
                    <!---->
                <!--</div>-->
                <div class="social-wrapper" v-if="show">
                    <social-sharing inline-template class="social social-click">
                        <div>
                            <a href="#" class="fb">
                                <network network="facebook">
                                    <img src="/static/svg/fb.svg" alt="Facebook">
                                </network>
                            </a>
                            <a href="#" class="tw">
                                <network network="twitter">
                                    <img src="/static/svg/twitter.svg" alt="Twitter">
                                </network>
                            </a>
                            <a href="#" class="vk">
                                <network network="vk">
                                    <img src="/static/svg/vk.svg" alt="Vkontakte">
                                </network>
                            </a>
                        </div>
                    </social-sharing>
                    <a href="#" class="ok" @click.prevent="shareOk">
                        <span>
                            <img src="/static/svg/ok.svg" alt="Vkontakte">
                        </span>
                    </a>
                </div>



            </transition>

            <a v-if="mobile" class="mobile-menu-btn desktop-hidden"  @click.prevent = "mobMenuToggle" :class="{ close: mobMenuShow }">
                <span></span>
                <span></span>
                <span></span>
            </a>
            <transition name="fade">
            <div class="mobile-menu-wrap desktop-hidden" v-if="mobMenuShow">
                <div class="valign">
                    <h3 class="mobile-menu-title">Содержание</h3>
                    <ul class="mobile-menu">
                        <li><router-link to="/" @click.prevent.native = "mobMenuToggle" class="menu-link">Наш тест</router-link></li>
                        <li><router-link to="/recipes" @click.prevent.native = "mobMenuToggle" class="menu-link">Рецепты</router-link></li>
                        <li><router-link to="/about" @click.prevent.native = "mobMenuToggle" class="menu-link">О продукте</router-link></li>
                    </ul>
                    <div class="social-wrapper">
                        <social-sharing inline-template class="social">
                            <div>
                                <a href="#" class="fb">
                                    <network network="facebook">
                                        <img src="/static/svg/fb.svg" alt="Facebook">
                                    </network>
                                </a>
                                <a href="#" class="tw">
                                    <network network="twitter">
                                        <img src="/static/svg/twitter.svg" alt="Twitter">
                                    </network>
                                </a>
                                <a href="#" class="vk">
                                    <network network="vk">
                                        <img src="/static/svg/vk.svg" alt="Vkontakte">
                                    </network>
                                </a>

                            </div>
                        </social-sharing>
                        <a href="#" class="ok" @click.prevent="shareOk">
                            <span>
                                <img src="/static/svg/ok.svg" alt="Vkontakte">
                            </span>
                        </a>
                    </div>


                </div>
            </div>
            </transition>
    </menu>

</template>

<script>

    let links = {
        'Index': [
            {path: '/',name:''},
            {path: '/',name:''}
        ],
        'TestStart': [
            {path: '/recipes',name:'Рецепты'},
            {path: '/about',name:'О продукте'}

//            {path: '/',name:''},
//            {path: '/',name:''}
        ],
        'TestMain': [
            {path: '/recipes',name:'Рецепты'},
            {path: '/about',name:'О продукте'}
        ],
        'Result': [
            {path: '/recipes',name:'Рецепты'},
            {path: '/about',name:'О продукте'}
        ],
        'Recipes': [
            {path: '/about',name:'О продукте'},
            {path: '/',name:'Наш тест'}
        ],
        'Recipe': [
            {path: '/about',name:'О продукте'},
            {path: '/',name:'Наш тест'}
        ],
        'About': [
            {path: '/',name:'Наш тест'},
            {path: '/recipes',name:'Рецепты'}
        ],


        ///
        'RecipesTest': [
            {path: '/about',name:'О продукте'},
            {path: '/',name:'Наш тест'}
        ],
    }

    import Arrow from '../../assets/svg/arrow.svg';
    import Share from '../../assets/svg/share.svg';
    import Twitter from '../../assets/svg/twitter.svg';
    import FB from '../../assets/svg/fb.svg';
    import OK from '../../assets/svg/ok.svg';
    import VK from '../../assets/svg/vk.svg';
    import socialSharing from 'vue-social-sharing';

    import Helpers from '@/tools/Helpers';

    export default {
        name: 'MainNav',
        computed : {
            links() {
//                console.log(this.$route.name);
                return (this.$route.name in links)?links[this.$route.name]:false;
            },
         },

//        props: ['mobMenuShow', 'mobMenuToggle', 'mobile'],

        props: {
            mobMenuShow:{
            },
            mobMenuToggle:{

            },
            mobile:{
            },
        },
        watch: {
            '$route' () {
                this.turnNavMenu();
            }
        },
        methods: {

            shareOk () {
                Helpers.shareOk();
                ga('send', 'event', 'redirect', 'show', 'Odnoklassniki share click');
            },

            turnNavMenu () {
                var self = this;
                console.log(self.$route.name);
                switch (self.$route.name) {
                    case 'TestStart':
                        self.animTurn = '';
                        self.bottomNav.link = '';
                        self.bottomNav.text = '';
                        self.testNavLink = '/';
                        break;
                    case 'Recipes':
                        self.animTurn = 'turn-r';
                        self.bottomNav.link = '/about';
                        self.bottomNav.text = 'О продукте';
                        self.testNavLink = '/';
                        break;
                    case 'Recipe':
                        self.animTurn = 'turn-r';
                        self.bottomNav.link = '/about';
                        self.bottomNav.text = 'О продукте';
                        self.testNavLink = '/';
                        break;
                    case 'About':
                        self.animTurn = 'turn-l';
                        self.bottomNav.link = '/recipes';
                        self.bottomNav.text = 'Рецепты';
                        self.testNavLink = '/';
                        break;

                    case 'TestMain':
                        self.animTurn = '';
                        self.bottomNav.link = '';
                        self.bottomNav.text = '';
                        self.testNavLink = '/test';
                }
            },

            showSharing(){
                let self = this;
                self.show = !self.show;
                if(self.show == true){
                    ga('send', 'event', 'click', 'show', 'Show Sharing');
                }
            },
            gaNav(event){
                ga('send', 'event', 'click', 'show', 'Click Nav Button To: ' + this.$route.path);
            }
        },
        components: {
            Arrow,
            Share,
            Twitter,
            FB,
            VK,
            OK,
            socialSharing
        },

        data() {
            return {
                show: false,
                animTurn: '',
                bottomNav: {
                    link: '',
                    text:''
                },
                testNavLink: ''
            }
        },
        mounted () {
            this.turnNavMenu ();
        }
}
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: all .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active для <2.1.8 */ {
        opacity: 0;
        transform: translate3d(0, 20%, 0)
    }
    .fade-in-enter-active {
        transition: all .5s
    }
    .fade-in-enter, .fade-in-leave-to /* .fade-leave-active для <2.1.8 */ {
        opacity: 0;
    }
</style>




// WEBPACK FOOTER //
// MainNav.vue?4fdce6af